/**
 * Description Info (ORCH-415)
 *
 * Purpose: The small info icon beside a permission or area label in the Role
 *          Manager. Hovering or focusing it shows the catalog's plain-language
 *          description. Renders nothing when the catalog has no description.
 */

import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

interface DescriptionInfoProps {
  /** The key the test id is built from. */
  itemKey: string;
  label: string;
  description?: string | null;
}

const DescriptionInfo: React.FC<DescriptionInfoProps> = ({ itemKey, label, description }) => {
  if (!description) return null;
  return (
    <Tooltip title={description}>
      <IconButton
        size="small"
        aria-label={`About ${label}`}
        data-testid={`info-${itemKey}`}
        sx={{ p: 0.25 }}
      >
        <InfoOutlined sx={{ fontSize: 16 }} color="action" />
      </IconButton>
    </Tooltip>
  );
};

export default DescriptionInfo;
